// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/info/person-info.scss
// module id = 494
// module chunks = 0